import ApiClient from './ApiClient'
import { withQuery } from '../../utils/urlParams'

const reportingBase = (collectId, draftId) => {
  if (draftId)
    return `/collects/${collectId}/drafts/${draftId}/reporting`
  return `/collects/${collectId}/reporting`
}

const measureParams = options => {
  const {
    startDate, endDate, granularity, operatorId, resourceSearch, variableId, questionId
  } = options
  return [
    ['start_date', startDate],
    ['end_date', endDate],
    ['granularity', granularity],
    ['operator_id', operatorId],
    ['variable_ids[]', variableId],
    ['q', resourceSearch],
    ['question_ids[]', questionId]
  ]
}

const listParams = options => {
  const {
    startDate, endDate, page, perPage,
    sortBy, sortDirection, operatorId, resourceSearch, variableId
  } = options
  return [
    ['start_date', startDate],
    ['end_date', endDate],
    ['variable_ids[]', variableId],
    ['page', page],
    ['per_page', perPage],
    ['sort_by', sortBy],
    ['sort_direction', sortDirection],
    ['operator_id', operatorId],
    ['q', resourceSearch]
  ]
}

const dispatchWithResourceIds = (url, resourceIds) => {
  if (resourceIds.length === 0)
    return ApiClient.get(url)
  /* eslint-disable-next-line camelcase */
  return ApiClient.post(url, { resource_ids: resourceIds })
}

class ProgressionService {
  static fetchMeasure(collectId, draftId, params = {}) {
    const { name, resourceIds = [], ...options } = params
    const baseUrl = `${reportingBase(collectId, draftId)}/measures/${name}.json`
    return dispatchWithResourceIds(withQuery(baseUrl, measureParams(options)), resourceIds)
  }

  static fetchList(collectId, draftId, params = {}) {
    const { name, resourceIds = [], ...options } = params
    const baseUrl = `${reportingBase(collectId, draftId)}/lists/${name}.json`
    return dispatchWithResourceIds(withQuery(baseUrl, listParams(options)), resourceIds)
  }

  static fetchOperatorOptions(collectId, draftId) {
    return ApiClient.get(`${reportingBase(collectId, draftId)}/operator_options.json`)
  }

  static fetchResourceOptions(collectId, draftId) {
    return ApiClient.get(`${reportingBase(collectId, draftId)}/resource_options.json`)
  }

  static fetchMeta(collectId, draftId) {
    return ApiClient.get(`${reportingBase(collectId, draftId)}/meta.json`)
  }

  static fetchSectionDetails(collectId, draftId, params = {}) {
    const { sectionId, resourceIds = [], startDate, endDate } = params
    const url = withQuery(`${reportingBase(collectId, draftId)}/section_details/${sectionId}.json`, [
      ['start_date', startDate],
      ['end_date', endDate]
    ])
    return dispatchWithResourceIds(url, resourceIds)
  }
}

export default ProgressionService
